
import { mapGetters } from 'vuex';
import BorrowerPreview from '~/assets/images/project/borrower-card-bg.png'
import InvestorPreview from '~/assets/images/project/borrower-card-bg.png'

export default {
    name: 'FormattedImage',
    props: {
        src: {
            type: String,
            default: '',
        },
    },
    computed: {
        imgSrc() {
            if (this.src) {
                return this.src;
            }
            return this.role === 'borrower'
                ? BorrowerPreview
                : InvestorPreview;
        },
        ...mapGetters('profile', ['role']),
    },
};
